import React, { useEffect, useState, useMemo } from "react";
import "./clasament.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFire,
  faCoins,
  faTrophy,
  faStar,
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons";



export default function Clasament() {
  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);
  const [loading, setLoading] = useState(true);
  const [weeklyStats, setWeeklyStats] = useState(null);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [showInfo, setShowInfo] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;



  // Calculeaza timpul ramas pana duminica 23:59:59
  const getTimeUntilSunday = () => {
    const now = new Date();
    const sunday = new Date(now);
    // Daca azi e duminica (0), nu adauga 7 zile, ci seteaza pentru azi
    sunday.setDate(now.getDate() + (now.getDay() === 0 ? 0 : 7 - now.getDay()));
    sunday.setHours(23, 59, 59, 999);
    const diff = sunday - now;
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((diff % (1000 * 60)) / 1000)
    };
  };

  // Actualizeaza countdown-ul
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeUntilSunday());
    }, 1000);
    return () => clearInterval(timer);
  }, []);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${apiUrl}/leaderboard?type=weekly`, {
          credentials: "include"
        });
        const data = await res.json();

        // Generam date zilnice simulate pentru demonstratie
        const generateDailyStats = (weeklyXP) => {
          const days = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];
          const dailyData = [];
          let remaining = weeklyXP;
          
          for (let i = 0; i < 7; i++) {
            const isToday = i === new Date().getDay() - 1;
            const xp = isToday ? Math.floor(remaining / (7 - i)) : 
                       i < new Date().getDay() - 1 ? Math.floor(Math.random() * (weeklyXP / 7) + 10) : 0;
            dailyData.push({ day: days[i], xp, isToday });
            remaining -= xp;
          }
          return dailyData;
        };

        if (Array.isArray(data)) {
          const mapped = data.map((row, idx) => ({
            position: row.position || idx + 1,
            username: row.username,
            avatar: row.profile_picture,
            points: row.xp ?? row.points ?? 0,
            weeklyXP: row.weekly_xp ?? row.xp ?? row.points ?? 0,
            dailyStats: generateDailyStats(row.weekly_xp ?? row.xp ?? row.points ?? 0),
            streak: row.streak ?? 0,
            user_id: row.user_id || row.id,
            trend: row.trend ?? 0 // ↑↓ schimbare față de săptămâna trecută
          }));

          setLeaderboard(mapped);

          const localUserId = localStorage.getItem('userId');
          if (localUserId) {
            const meRow = mapped.find(u => String(u.user_id) === String(localUserId));
            if (meRow) {
              setUserRank({ ...meRow });
            } else {
              setUserRank(null);
            }
          } else {
            setUserRank(null);
          }
        } else {
          setLeaderboard(data.list || []);
          if (data.me) {
            setUserRank({
              ...data.me,
              dailyStats: generateDailyStats(data.me.weeklyXP || data.me.points || 0)
            });
          } else {
            setUserRank(null);
          }
        }

        // Statistici saptamana
        setWeeklyStats({
          topPromoted: 10,
          bottomDemoted: 5,
          totalUsers: data.length || 0
        });
      } catch (err) {
        console.error("Eroare leaderboard:", err);
      }
      setLoading(false);
    };

    setLoading(true);
    fetchData();
  }, [apiUrl]);
  // Sorteaza leaderboard dupa puncte (XP) descrescator si recalculam pozitiile
  const sortedLeaderboard = useMemo(() => {
    const arr = (leaderboard || []).slice();
    arr.sort((a, b) => {
      const pa = Number(a.points ?? a.xp ?? 0);
      const pb = Number(b.points ?? b.xp ?? 0);
      return pb - pa;
    });

    return arr.map((u, idx) => ({ ...u, position: u.position || idx + 1 }));
  }, [leaderboard]);

  // Actualizeaza userRank pentru afisare folosind pozitia calculata din sortedLeaderboard
  const displayUserRank = useMemo(() => {
    if (!userRank) return null;
    const found = sortedLeaderboard.find(u => String(u.user_id) === String(userRank.user_id));
    return found ? { ...userRank, position: found.position, points: found.points } : userRank;
  }, [userRank, sortedLeaderboard]);

  if (loading) return (
    <div className="welcome-screen-lesson">
      <div className="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );

  return (

    <div className="clasament-page">
      {/* HERO */}
      <div className="clasament-hero" style={{position: 'relative'}}>
        <FontAwesomeIcon icon={faTrophy} className="hero-icon" />
        <h2 className="hero-title">Clasament Saptamanal</h2>
        {/* FontAwesome Info Button */}
        <button
          className="info-btn"
          style={{position: 'absolute', top: 20, right: 30, background: 'none', border: 'none', fontSize: '2rem', cursor: 'pointer', color: '#fff'}}
          onClick={() => setShowInfo(true)}
          aria-label="Informatii clasament"
        >
          <FontAwesomeIcon icon={faInfoCircle} />
        </button>
        {/* Countdown */}
        <div className="countdown-wrapper">
          <span className="countdown-label">Saptamana se termina in:</span>
          <div className="countdown-timer">
            <div className="time-block">
              <span className="time-value">{timeLeft.days}</span>
              <span className="time-label">zile</span>
            </div>
            <span className="time-separator">:</span>
            <div className="time-block">
              <span className="time-value">{String(timeLeft.hours).padStart(2, '0')}</span>
              <span className="time-label">ore</span>
            </div>
            <span className="time-separator">:</span>
            <div className="time-block">
              <span className="time-value">{String(timeLeft.minutes).padStart(2, '0')}</span>
              <span className="time-label">min</span>
            </div>
            <span className="time-separator">:</span>
            <div className="time-block">
              <span className="time-value">{String(timeLeft.seconds).padStart(2, '0')}</span>
              <span className="time-label">sec</span>
            </div>
          </div>
        </div>
      </div>

      {/* Info Modal */}
      {showInfo && (
        <div className="clasament-info-modal" style={{position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.4)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <div style={{background: 'white', borderRadius: '16px', padding: '2rem', maxWidth: '90vw', width: '400px', boxShadow: '0 2px 16px rgba(0,0,0,0.2)', position: 'relative'}}>
            <button
              onClick={() => setShowInfo(false)}
              style={{position: 'absolute', top: 10, right: 10, background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer'}}
              aria-label="Inchide informatii"
            >✖️</button>
            <div style={{fontSize: '1.2rem', whiteSpace: 'pre-line'}}>
              <span style={{fontSize: '2rem'}}>🏆</span> <b>Cum funcționează clasamentul</b>
              <br/><br/>
              <span style={{fontSize: '1.3rem'}}>🔼 Top 10</span>
              <br/>→ Promovezi în liga superioară
              <br/><br/>
              <span style={{fontSize: '1.3rem'}}>➖ Locurile 11–50</span>
              <br/>→ Rămâi în aceeași ligă
              <br/><br/>
              <span style={{fontSize: '1.3rem'}}>🔽 Ultimele 10</span>
              <br/>→ Retrogradezi în liga inferioară
              <br/><br/>
              Clasamentul se resetează în fiecare săptămână.
              <br/>Contează doar XP-ul acumulat.
            </div>
          </div>
        </div>
      )}


      {/* INFO POZITIE */}
      <div className="league-info-banner">
        <div className="info-item promotion">
          <span className="info-icon"><FontAwesomeIcon icon={faTrophy} /></span>
          <div>
              {/* Poziția ta */}
              <div style={{fontWeight: 'bold', fontSize: '1.1em', marginBottom: 2}}>
                Poziția ta
              </div>
              <div style={{fontSize: '1em'}}>
                Locul {displayUserRank?.position ?? '-'} din {weeklyStats?.totalUsers ?? '-'}
              </div>
              {typeof displayUserRank?.trend === 'number' && (
                <div style={{color: displayUserRank.trend > 0 ? 'green' : displayUserRank.trend < 0 ? 'red' : 'gray', fontWeight: 'bold', fontSize: '0.95em'}}>
                  {displayUserRank.trend > 0 ? '↑ +' : displayUserRank.trend < 0 ? '↓ ' : ''}{Math.abs(displayUserRank.trend)} față de ieri
                </div>
              )}
          </div>
        </div>
      </div>

      {/* CARD UTILIZATOR CURENT */}
      {displayUserRank && (
        <div className="my-rank-card">
          <div className="my-rank-header">
            <div className="my-rank-info">
              <img
                src={displayUserRank.avatar || "https://i.pravatar.cc/80"}
                alt="avatar"
                className="my-avatar"
              />
              <div>
                <p className="rank-position">
                  <FontAwesomeIcon icon={faTrophy} /> Locul <b>{displayUserRank.position}</b>
                  {displayUserRank.position <= 10 && <span className="promo-badge">🚀 Top 10</span>}
                  {displayUserRank.position > (weeklyStats?.totalUsers - 5) && <span className="demo-badge">⚠️ Ultimii 5</span>}
                </p>
                <p>
                  <FontAwesomeIcon icon={faCoins} /> <strong>{displayUserRank.weeklyXP || displayUserRank.points} XP</strong> aceasta saptamana
                </p>
                <p>
                  <FontAwesomeIcon icon={faFire} /> Streak: {displayUserRank.streak} zile
                </p>
              </div>
            </div>
          </div>
          {/* Progres zilnic */}
          {displayUserRank.dailyStats && (
            <div className="daily-progress">
              <h4 className="daily-title">Progres zilnic</h4>
              <div className="daily-bars">
                {displayUserRank.dailyStats.map((day, idx) => (
                  <div key={idx} className={`daily-bar-wrapper ${day.isToday ? 'today' : ''}`}>
                    <div className="daily-bar" style={{ height: `${Math.min((day.xp / 100) * 100, 100)}%` }}>
                      <span className="bar-value">{day.xp}</span>
                    </div>
                    <span className="daily-label">{day.day}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}



      {/* TOP 3 GLOBAL PE TAB */}
      <div className="top3-wrapper">
        {sortedLeaderboard.slice(0, 3).map((user, index) => (
          <div key={index} className={`top3-card pos-${index + 1}`}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', paddingTop: '16px' }}>
            <img
              src={user.avatar || "https://i.pravatar.cc/80"}
              className="top3-avatar"
              alt="avatar"
              style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', marginBottom: '10px' }}
            />
            <h4 style={{ margin: '0 0 6px 0', fontWeight: 600 }}>{user.username}</h4>
            <p style={{ margin: 0, fontWeight: 500 }}>{user.points} XP</p>
          </div>
        ))}
      </div>

      {/* LISTA CLASAMENT */}
      <div className="rank-list">
        {sortedLeaderboard.length === 0 && (
          <div className="empty-state">
            <FontAwesomeIcon icon={faTrophy} className="empty-icon" />
            <p>Nu exista date pentru acest clasament.</p>
            <p>Completeaza lectii pentru a intra in top!</p>
          </div>
        )}

        {sortedLeaderboard.slice(3).map((user, index) => {
          const actualPosition = user.position;
          const isPromotion = actualPosition <= 10;
          const isDemotion = actualPosition > (sortedLeaderboard.length - 5);
          return (
            <div key={index} className={`rank-item ${
              isPromotion ? 'promotion-zone' : 
              isDemotion ? 'demotion-zone' : 'safe-zone'
            }`}>
              <div className="rank-main">
                <div className="rank-left">
                  <span className={`rank-pos ${isPromotion ? 'promo' : isDemotion ? 'demo' : ''}`}>
                    {actualPosition}
                  </span>
                  <img
                    src={user.avatar || "https://i.pravatar.cc/70"}
                    className="rank-avatar"
                    alt="avatar"
                  />
                  <div className="rank-user-info">
                    <p className="rank-name">{user.username}</p>
                    <p className="rank-xp">
                      <FontAwesomeIcon icon={faCoins} /> <strong>{user.weeklyXP || user.points} XP</strong> saptamana aceasta
                    </p>
                    <p className="rank-streak">
                      <FontAwesomeIcon icon={faFire} /> {user.streak} zile
                    </p>
                  </div>
                </div>
                <div className="rank-right">
                  <span className="rank-badge">
                    <FontAwesomeIcon icon={faStar} />
                  </span>
                  {user.trend !== 0 && (
                    <span className={`trend ${user.trend > 0 ? 'up' : 'down'}`}>
                      {user.trend > 0 ? '↑' : '↓'} {Math.abs(user.trend)}
                    </span>
                  )}
                </div>
              </div>
              {/* Mini progres zilnic */}
              {user.dailyStats && (
                <div className="mini-daily-progress">
                  {user.dailyStats.map((day, idx) => (
                    <div key={idx} className="mini-bar" title={`${day.day}: ${day.xp} XP`}>
                      <div className="mini-bar-fill" style={{ height: `${Math.min((day.xp / 100) * 100, 100)}%` }}></div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
